export default __webpack_public_path__ + "static/media/sad.2091686a.gif";